module.exports = __webpack_public_path__ + "static/media/whiteRose.80364fec.jpeg";